import { BuildervalidationErrorClass } from "./builder-validation-error.class";

export class BuilderBaseValidationSummaryModel {
    hasValidationErrors: boolean = false;
    passedValidations: boolean = false;
    validationErrors: BuildervalidationErrorClass[] = [];
}